module.exports = __webpack_public_path__ + "f49566fa02503a132df32ab22b94be15.pdf";